import { Text, View } from 'react-native'

import { styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      gap: theme.spacingInlineOnepulse,
      backgroundColor: 'transparent',
      alignItems: 'center',
    },
    variants: {
      size: {
        md: {
          paddingHorizontal: theme.paddingInsetFourpulse,
        },
        ml: {
          paddingHorizontal: theme.paddingInsetFourpulse,
        },
        lg: {
          paddingHorizontal: theme.paddingInsetFivepulse,
        },
        xl: {
          paddingHorizontal: theme.paddingInsetSixpulse,
        },
      },
    },
  }
})

export const Label = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextDangerAlternative,
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      textAlign: 'left',
      textAlignVertical: 'top',
    },
    variants: {},
  }
})
